export default "__VITE_ASSET__qMtBQT3B__"